// FoxMark v1.0 (T635, Saul 2026-10-10): the real MentionFox fox head (/fox-head.png, 150x157).
// Rule: never an emoji or a generic/redrawn fox as a logo, icon, avatar or glyph. Use this.
import type { CSSProperties } from "react";

interface FoxMarkProps {
  /** Rendered height in px; width follows the real 150:157 aspect. */
  size?: number;
  className?: string;
  style?: CSSProperties;
  /** Empty by default (decorative next to a text label). */
  alt?: string;
  title?: string;
}

export function FoxMark({ size = 16, className, style, alt = "", title }: FoxMarkProps) {
  const height = size;
  const width = Math.round((size * 150) / 157);
  return (
    <img
      src="/fox-head.png"
      alt={alt}
      title={title}
      width={width}
      height={height}
      className={className}
      style={{ display: "inline-block", verticalAlign: "middle", objectFit: "contain", ...style }}
      draggable={false}
    />
  );
}

export default FoxMark;

/** Sentinel for string icon fields (lists of emoji glyphs): render it with <IconGlyph>. */
export const FOX_ICON = "fox-mark";

/** Renders a string icon field: the real fox for FOX_ICON, the string itself otherwise. */
export function IconGlyph({ value, size = 14, className }: { value?: string | null; size?: number; className?: string }) {
  if (!value) return null;
  if (value === FOX_ICON) return <FoxMark size={size} className={className} />;
  return <>{value}</>;
}
